import moment from 'moment'
import React, { useContext } from 'react'

import { getFacialType } from 'utils/helper-functions'
import useNavigate from 'utils/navigation/useCustomNavigate'
import useServices from 'views/hooks/useServices'
import { AppContext } from '../../../providers/context/App'

import { ReactComponent as MapPinIcon } from '../../../assets/icons/map-pin-1-new.svg'
import './appointment.scss'

const AppointmentHeader = () => {
  const { appMasterData } = useContext(AppContext)
  const { isInfluencerFlow } = useNavigate()
  const { facialName } = useServices()

  return (
    <div className="general-head">
      <h3 className="main-head">
        {isInfluencerFlow ? facialName : getFacialType(appMasterData)}{' '}
        {!appMasterData.selectedEsthetician.isAny ? (
          <>
            <br />
            with {appMasterData.selectedEsthetician.staff.firstName}{' '}
            {appMasterData.selectedEsthetician.staff.lastName.charAt(0)}.
          </>
        ) : (
          ''
        )}
      </h3>
      <div className="sub-head">
        {moment(appMasterData.selectedDate).format('dddd, MMM DD')} @{' '}
        {moment
          .tz(appMasterData.selectedTime.startTime, appMasterData.location.tz)
          .format('h:mm A')}
      </div>
      <div className="body-1">
        <MapPinIcon className="mappin-icon" />{' '}
        <span className="location-name">{appMasterData.location.name}</span>
      </div>
    </div>
  )
}

export default React.memo(AppointmentHeader)
